// extracted by mini-css-extract-plugin
module.exports = {"listItem":"_36rvV","link":"_17lpC","facebook":"_25MMG","twitter":"_208PD"};